export const MIN_ITEMS_FOR_CONTROLS = 10;
export const DEFAULT_LIMIT = 50;

export const LIMIT_OPTIONS = [
  { label: '10', value: 10 },
  { label: '25', value: 25 },
  { label: '50', value: 50 },
  { label: '100', value: 100 }
];

export const DEFAULT_FILTERS_DEFS = {
  name: {
    title: 'Name',
    values: null,
    allowed_operators: ['contains', 'does not contain'],
    icon: 'text-num-mono'
  }
};

export const DEFAULT_COLUMNS = [
  {
    field: 'selector',
    headerName: '',
    maxWidth: 90,
    hide: false,
    suppressMenu: true,
    sortable: false,
    filter: false,
    suppressNavigable: true
  },
  {
    field: 'name',
    headerName: 'Name',
    hide: false
  },
  {
    field: 'assignments',
    headerName: 'Assigned staff members',
    flex: 1,
    hide: false
  }
];

/**
 * @param {Object} apiData - API response with steps and substeps arrays
 * @param {Array} uiSteps - UI state with checked status
 * @returns {Array} Merged steps with assignments from API and checked state from UI
 */
export function mergeAssignments(apiData, uiSteps) {
  const apiSteps = Array.isArray(apiData?.steps) ? apiData.steps : [];
  const apiSubsteps = Array.isArray(apiData?.substeps) ? apiData.substeps : [];
  const secondSteps = Array.isArray(uiSteps) ? uiSteps : [];

  const uiStepById = new Map();
  const uiStepByCode = new Map();
  for (const s of secondSteps) {
    if (s && typeof s === 'object') {
      if (s.step_id != null) uiStepById.set(s.step_id, s);
      if (s.id != null) uiStepById.set(s.id, s);
      if (s.code) uiStepByCode.set(s.code, s);
    }
  }

  const uiSubById = new Map();
  const uiSubByCode = new Map();
  for (const step of secondSteps) {
    if (Array.isArray(step.substeps)) {
      for (const sub of step.substeps) {
        if (sub && typeof sub === 'object') {
          if (sub.substep_id != null) uiSubById.set(sub.substep_id, sub);
          if (sub.id != null) uiSubById.set(sub.id, sub);
          if (sub.code) uiSubByCode.set(sub.code, sub);
        }
      }
    }
  }

  const subById = new Map();
  const subByCode = new Map();
  for (const s of apiSubsteps) {
    if (s && typeof s === 'object') {
      if (s.substep_id != null) subById.set(s.substep_id, s);
      if (s.substep_code) subByCode.set(s.substep_code, s);
    }
  }

  return apiSteps.map((apiStep) => {
    const uiStep = uiStepById.get(apiStep.step_id) || uiStepByCode.get(apiStep.step_code);

    const uiSubsteps = uiStep?.substeps || [];

    const mergedSubsteps = uiSubsteps.map((uiSub) => {
      const apiSub =
        subById.get(uiSub.substep_id) || subById.get(uiSub.id) || subByCode.get(uiSub.code);
      return {
        ...uiSub,
        substep_id: uiSub.substep_id || uiSub.id,
        assignments: apiSub?.assignments || []
      };
    });

    return {
      id: apiStep.step_id,
      step_id: apiStep.step_id,
      code: apiStep.step_code,
      name: apiStep.step_name,
      status: apiStep.step_status,
      due_date: apiStep.step_due_date,
      checked: uiStep?.checked || false,
      assignments: apiStep.assignments || [],
      substeps: mergedSubsteps
    };
  });
}
